import { render, staticRenderFns } from "./historyFile.vue?vue&type=template&id=651b1fd9&scoped=true&"
import script from "./historyFile.vue?vue&type=script&lang=js&"
export * from "./historyFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b1fd9",
  null
  
)

export default component.exports